module.exports = function() {
  return new Worker(__webpack_public_path__ + "0ceff51b332449b2739c.worker.js");
};